import type { CSSProperties } from "react";

/** 订单详情页布局配置（修改 `STORE_ORDER_DETAIL_LAYOUT` 即可全局生效） */
export interface StoreOrderDetailLayoutConfig {
  /** 订单卡片圆角（px） */
  cardBorderRadius: number;
  /** 操作按钮圆角（px）：立即支付、再次购买、重新购买、进入服务 */
  buttonBorderRadius: number;
  /** 已支付主操作行：再次购买与进入服务之间的间距（px） */
  paidActionButtonsGap: number;
  /**
   * 已支付主操作行：再次购买按钮宽度比例（flex-grow）。
   * 与 paidServiceButtonFlex 共同决定两按钮宽度，例如 5:3 表示再次购买约占 5/8。
   */
  paidRepurchaseButtonFlex: number;
  /**
   * 已支付主操作行：进入服务按钮宽度比例（flex-grow）。
   * 数值小于 paidRepurchaseButtonFlex 时，进入服务会更窄。
   */
  paidServiceButtonFlex: number;
}

export const STORE_ORDER_DETAIL_LAYOUT = {
  cardBorderRadius: 10,
  buttonBorderRadius: 6,
  paidActionButtonsGap: 10,
  paidRepurchaseButtonFlex: 2,
  paidServiceButtonFlex: 5,
} as const satisfies StoreOrderDetailLayoutConfig;

export function storeOrderDetailLayoutCssVars(
  config: StoreOrderDetailLayoutConfig = STORE_ORDER_DETAIL_LAYOUT
): CSSProperties {
  return {
    ["--lf-store-order-detail-card-radius" as string]: `${config.cardBorderRadius}px`,
    ["--lf-store-order-detail-btn-radius" as string]: `${config.buttonBorderRadius}px`,
    ["--lf-store-order-detail-paid-actions-gap" as string]: `${config.paidActionButtonsGap}px`,
    ["--lf-store-order-detail-paid-repurchase-flex" as string]: String(config.paidRepurchaseButtonFlex),
    ["--lf-store-order-detail-paid-service-flex" as string]: String(config.paidServiceButtonFlex),
  };
}
